module.exports = __webpack_public_path__ + "img/KinokoTable74.78b2f571.jpg";